export default __webpack_public_path__ + "static/wild-hearts-e3d48138a4af6c0bd91cf7d274fb77af.jpg";